import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import depositFormMeta, { IDepositFormMeta } from "./DepositFormMeta";
import disksFormMeta, { IDisksFormMeta } from "./DisksFormMeta";
import displayFormMeta, { IDisplayFormMeta } from "./DisplayFormMeta";
import distributorFormMeta, { IDistributorFormMeta } from "./DistributorFormMeta";
import indicatorsFormMeta, { I_IndicatorsFormMeta } from "./IndicatorsFormMeta";


export interface IHardwareConfiguration2FormMeta extends IDepositFormMeta, IDistributorFormMeta, IDisksFormMeta, I_IndicatorsFormMeta, IDisplayFormMeta {
  
  schema: any;
}

let hardwareConfiguration2FormMeta = {} as IHardwareConfiguration2FormMeta;

hardwareConfiguration2FormMeta = { ...hardwareConfiguration2FormMeta, ...depositFormMeta, ...distributorFormMeta, ...disksFormMeta, ...indicatorsFormMeta, ...displayFormMeta };

hardwareConfiguration2FormMeta.schema = yup.object().shape(getValidationSchema(hardwareConfiguration2FormMeta));

export default hardwareConfiguration2FormMeta;